import * as CookieConsent from 'vanilla-cookieconsent';
// import IframeManager from './iframemanager';

import DE from './translations/de.json';
import EN from './translations/en.json';

// const documentLang = document.documentElement.getAttribute('lang');
const defaultLang = 'en';

/**
 * All config. options available here:
 * https://cookieconsent.orestbida.com/reference/configuration-reference.html
 */

const cookieConsentConfig = {
    categories: {
        necessary: {
            enabled: true,  // this category is enabled by default
            readOnly: true  // this category cannot be disabled
        },
        /*
        functional: {
            services: {
                youtube: {
                    label: 'YouTube Video Player',
                    // onAccept: () => IframeManager.acceptService('youtube'),
					// onReject: () => IframeManager.rejectService('youtube')
                },
            }
        },
        */
        analytics: {},
        marketing: {}
    },
    language: {
        default: defaultLang,
        autoDetect: 'document',
        translations: {
            'de': DE.cookieConsent,
            'en': EN.cookieConsent,
        }
    },
    guiOptions: {
        consentModal: {
            layout: "box wide",
            position: "middle center",
            equalWeightButtons: true,
            flipButtons: false
        },
        preferencesModal: {
            layout: "box",
            position: "right",
            equalWeightButtons: true,
            flipButtons: false
        }
    },
    hideFromBots: !navigator.userAgent.includes ("Playwright")
    
}

if (location.hostname.indexOf ("pigsar.") >= 0 ||
	location.hostname.indexOf ("drc.") >= 0 ||
	location.hostname.indexOf ("delta-rhine-corridor.") >= 0) {
	delete cookieConsentConfig.categories.marketing;
	DE.cookieConsent.preferencesModal.sections.pop ();
	EN.cookieConsent.preferencesModal.sections.pop ();
	
}

/*
const iframeManagerTranslations = {
    'de': DE.iframeManager,
    'en': EN.iframeManager
}

const iframeManagerConfig = {
    onChange: ({ changedServices, eventSource }) => {
        if(eventSource.type === 'click') {
            const servicesToAccept = [
                ...CookieConsent.getUserPreferences().acceptedServices['functional'],
                ...changedServices
            ];

            CookieConsent.acceptService(servicesToAccept, 'functional');
        }
    },
    currLang: iframeManagerTranslations[documentLang] ? documentLang : defaultLang,
    autoLang: false,
    services : {
        youtube : {
            embedUrl: 'https://www.youtube-nocookie.com/embed/{data-id}',
            // thumbnailUrl: 'https://i3.ytimg.com/vi/{data-id}/hqdefault.jpg',
            iframe : {
                allow : 'accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen;',
            },
            cookie : {
                name : 'cc_youtube'
            },
            languages : iframeManagerTranslations
        }
    },
    disablePageInteraction: true
}
*/

const focusableChildren = new Array ();

function isFocusable (element) {
	if (!(element instanceof HTMLElement))
		return false;
	
	// https://stackoverflow.com/a/30753870/76472
	const knownFocusableElements =
		'a[href],area[href],button:not([disabled]),details,iframe,object,input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[contentEditable="true"],[tabindex]:not([tabindex^="-"])';
	if (element.matches (knownFocusableElements))
		return true;

	const isDisabledCustomElement =
	element.localName.includes ('-') && element.matches ('[disabled], [aria-disabled="true"]');
	if (isDisabledCustomElement)
		return false;

	return element.shadowRoot?.delegatesFocus ?? false;
	
};

function getShowsPreferences () {
	const cookieModalElement = document.querySelector ("#cc-main");
	
	return cookieModalElement.children [1]?.lastElementChild?.getAttribute ("aria-hidden") == "false";
	
}

function updateFocusableChildren () {
	const cookieModalElement = document.querySelector ("#cc-main");
	
	function getCookieCurrentDialog () {
		return getShowsPreferences () ?
			cookieModalElement.lastChild :
			cookieModalElement.firstChild;
		
	}
	
	const children = getCookieCurrentDialog ().querySelectorAll ("*");
	focusableChildren.length = 0;
	for (const child of children) {
		if (child.classList.contains ("pm__close-btn") ||
			child.tabIndex < 0 && child.nodeName == "DIV" && !child.textContent.trim () && !child.classList.contains ("pm-overlay")) {
			child.remove ();
			continue;
			
		}
		if (isFocusable (child)) {
			child.tabIndex = 1;
			focusableChildren.push (child);
			
		}
		
	}
	
	focusableChildren [0].addEventListener ("keydown", event => {
		if (event.keyCode == 9 && event.shiftKey) {
			event.preventDefault ();
			event.stopPropagation ();
		}
		
	});
	focusableChildren [focusableChildren.length - 1].addEventListener ("keydown", event => {
		if (event.keyCode == 9 && !event.shiftKey) {
			event.preventDefault ();
			event.stopPropagation ();
		}
		
	}, {once: true});
	
	const onFocus = event => {
		if (document.documentElement.classList.contains ("show--consent")) {
			let target = event.type == "focusin" ?
				event.target : document.activeElement;
			const cookieCurrentDialog = getCookieCurrentDialog ();
			
			while (target) {
				if (target == cookieCurrentDialog)
					return;
				
				target = target.parentNode;
				
			}
				
			event.preventDefault ();
			event.stopPropagation ();
			
			focusableChildren [0].focus ({focusVisible: false});
			
		} else {
			document.body.removeEventListener ("focusin", onFocus);
			document.body.removeEventListener ("click", onFocus);
			
		}
		
	}
	
	window.setTimeout (_ => {
		focusableChildren [0].focus ({focusVisible: false});
		
		document.body.addEventListener ("focusin", onFocus);
		document.body.addEventListener ("click", onFocus);
		
	}, 150);
	
}

window.addEventListener ("cc:onModalShow", ({detail}) => {
	updateFocusableChildren ();
	
});

window.addEventListener ("load", event => {
	CookieConsent.run (cookieConsentConfig);
	
	/*
	IframeManager.run (iframeManagerConfig);
	*/
	
	const GACookieHandler = window.GACookieHandler;
	
	if (GACookieHandler) {
		window.dataLayer = window.dataLayer || [];
		
		// Hilfsfunktion: Pusht die erlaubten Kategorien in den GTM dataLayer
		function pushConsentToGTM () {
			
			// Prüfen, welche Kategorien aktiv zugestimmt wurden
			const hasAnalytics = CookieConsent.acceptedCategory ("analytics");
			const hasMarketing = CookieConsent.acceptedCategory ("marketing");
			
			if (hasAnalytics) {
				window.dataLayer.push ({
					"event": "cookie_consent_analytics"
					
				});
				
			}
			// Custom Events für spezifische Tags (z.B. LinkedIn) feuern
			if (hasMarketing) {
				window.dataLayer.push ({
					"event": "cookie_consent_marketing"
					
				});
				
			}
			
			if (hasAnalytics || hasMarketing)
				GACookieHandler.enableGoogleAnalyticsMeasurement ();
			else
				GACookieHandler.disableGoogleAnalyticsMeasurement ();
			
			// Optional: GTM Google Consent Mode v2 aktualisieren
			if (typeof gtag === "function") {
				gtag ("consent", "update", {
					"analytics_storage": hasAnalytics ? "granted" : "denied",
					"ad_storage": hasMarketing ? "granted" : "denied",
					"ad_user_data": hasMarketing ? "granted" : "denied",
					"ad_personalization": hasMarketing ? "granted" : "denied"
					
				});
				
			}
			
		}
		
		/*
		window.addEventListener ("cc:onFirstConsent", ({detail}) => {
			pushConsentToGTM ();
			
		});
		*/
		window.addEventListener ("cc:onConsent", ({detail}) => {
			pushConsentToGTM ();
			
		});
		window.addEventListener ("cc:onChange", ({detail}) => {
			pushConsentToGTM ();
			
		});
		
	}
	
});
